const SKILL_POINTS = {
  keeperSkill: [0, 2, 12, 23, 39, 56, 76, 99, 123, 150, 183, 222, 268, 321, 380, 446, 519, 600, 691, 797, 924, 1074, 1278, 1278],
  defenderSkill: [0, 4, 18, 39, 65, 98, 134, 175, 221, 271, 330, 401, 484, 580, 689, 809, 942, 1092, 1268, 1487, 1791, 1791, 1791, 1791],
  playmakerSkill: [0, 4, 17, 34, 57, 84, 114, 150, 190, 231, 281, 341, 412, 493, 584, 685, 798, 924, 1070, 1247, 1480, 1791, 1791, 1791],
  wingerSkill: [0, 2, 12, 25, 41, 60, 81, 105, 132, 161, 195, 231, 287, 344, 407, 478, 555, 642, 741, 855, 995, 1172, 1360, 1360],
  passingSkill: [0, 3, 14, 31, 51, 75, 104, 137, 173, 213, 259, 315, 381, 457, 540, 607, 738, 854, 988, 1148, 1355, 1355, 1355, 1355],
  scorerSkill: [0, 4, 17, 36, 59, 88, 119, 156, 197, 240, 291, 354, 427, 511, 607, 713, 830, 961, 1114, 1300, 1547, 1547, 1547, 1547],
  setPiecesSkill: [0, 1, 2, 5, 9, 15, 21, 28, 37, 46, 56, 68, 81, 95, 112, 131, 153, 179, 210, 246, 287, 334, 388, 450],
}

const POSITION_SKILLS = {
  GK: ['keeperSkill', 'defenderSkill', 'setPiecesSkill'],
  CD: ['defenderSkill', 'playmakerSkill', 'setPiecesSkill'],
  WB: ['defenderSkill', 'wingerSkill', 'playmakerSkill', 'setPiecesSkill'],
  ETWB: ['defenderSkill', 'wingerSkill', 'playmakerSkill', 'setPiecesSkill'],
  CA: ['defenderSkill', 'wingerSkill', 'passingSkill', 'setPiecesSkill'],
  IM: ['defenderSkill', 'playmakerSkill', 'passingSkill', 'scorerSkill', 'setPiecesSkill'],
  W: ['defenderSkill', 'playmakerSkill', 'wingerSkill', 'passingSkill', 'scorerSkill', 'setPiecesSkill'],
  FW: ['playmakerSkill', 'passingSkill', 'wingerSkill', 'scorerSkill', 'setPiecesSkill'],
  PNF: ['playmakerSkill', 'passingSkill', 'wingerSkill', 'scorerSkill', 'setPiecesSkill'],
  TDF: ['playmakerSkill', 'passingSkill', 'wingerSkill', 'scorerSkill', 'setPiecesSkill'],
}

const POSITION_PATTERNS = [
  ['ETWB', /\bETWB\b/],
  ['PNF', /\bPNF\b/],
  ['TDF', /\bTDF\b/],
  ['GK', /\bGK\b|MAALIVAHTI/],
  ['CD', /\bCD\b|KESKUSPUOLUST/],
  ['WB', /\bWB\b|LAITAPUOLUST/],
  ['CA', /\bCA\b/],
  ['IM', /\bIM\b|INNER/],
  ['FW', /\bFW\b|HYÖKKÄÄJ/],
  ['W', /\bW\b|LAITURI/],
]

export const getDefaultPositionHtmsSkills = position =>
  POSITION_SKILLS[position] || []

export const getPositionHtmsSkills = candidate => {
  if (Array.isArray(candidate?.positionHtmsSkills)) {
    return candidate.positionHtmsSkills
  }
  return getDefaultPositionHtmsSkills(getCandidatePosition(candidate))
}

export const getCandidatePosition = candidate => {
  const sources = [candidate?.Name, candidate?.Position]

  for (const source of sources) {
    const value = String(source || '').toUpperCase()
    const match = POSITION_PATTERNS.find(([, pattern]) => pattern.test(value))
    if (match) return match[0]
  }

  return null
}

const getSkillPoints = (skill, value) => {
  const points = SKILL_POINTS[skill]
  const level = Number(value)
  if (!points || !Number.isFinite(level)) return null

  const clampedLevel = Math.min(Math.max(level, 0), points.length - 1)
  const lowerLevel = Math.floor(clampedLevel)
  const upperLevel = Math.ceil(clampedLevel)
  return (
    points[lowerLevel] +
    (clampedLevel - lowerLevel) * (points[upperLevel] - points[lowerLevel])
  )
}

export const calculatePositionHtms = (player, position, configuredSkills) => {
  const skills = configuredSkills || POSITION_SKILLS[position]
  if (!skills || !player?.playerSkills) return null

  const includedSkills =
    position === 'GK' && Number(player.specialty) === 4
      ? [...new Set([...skills, 'passingSkill'])]
      : skills
  const total = includedSkills.reduce((sum, skill) => {
    const points = getSkillPoints(skill, player.playerSkills[skill])
    return points === null ? NaN : sum + points
  }, 0)

  return Number.isFinite(total) ? Math.round(total) : null
}
